<template>
    <div id='AccessDenied'>
        <h1 style='text-align:center'>Accès non autorisé</h1>
        
        <div>
            <span>Votre profil n’a pas les droits pour consulter cette page.</span>
            <br/>
            <span>Nous vous invitons à vous rapprocher de votre administrateur.</span>
        </div>
        <br/>
        <router-link to='/accueil'>Retour à la page d’accueil</router-link>
    </div>
</template>

<script>
    export default {
        name: "AccessDenied",
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
